
// 插件路由
const franchise = () => import(/* webpackChunkName: "franchise" */ '~/addon/franchise/pages/franchise.vue')

const routes = [
	{ 
        path: '/franchise', 
        component: franchise 
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/franchise/router/index.js